export const mountDashboardTrips = (result: any) => {
  return {
    tripsInPeriod: result?.totalTrips,
    c02Emission: result?.totalCo2Emission,
    fuelConsumption: result?.totalFuelConsumption,
    distanceTraveled: result?.totalDistance,
    timeTotal: result?.totalTime,
    plannedCo2Emission: result?.plannedCo2Emission,
    plannedDistanceTraveled: result?.plannedDistance,
    plannedFuelConsumption: result?.plannedFuelConsumption,
    plannedTotalTime: result?.plannedTime,
  };
};